import { Controller } from "@hotwired/stimulus"

// Toggles a listing between grid and list layouts, persisting the choice in
// localStorage. Both layouts are rendered server-side; we only show/hide them.
//
//   <div data-controller="view-toggle">
//     <button data-view-toggle-target="gridBtn" data-action="view-toggle#grid">
//     <button data-view-toggle-target="listBtn" data-action="view-toggle#list">
//     <div data-view-toggle-target="grid"> ... </div>
//     <div data-view-toggle-target="list" class="hidden"> ... </div>
export default class extends Controller {
  static targets = ["grid", "list", "gridBtn", "listBtn"]
  static values = { storageKey: { type: String, default: "catalogView" } }

  connect() {
    this.apply(localStorage.getItem(this.storageKeyValue) === "list" ? "list" : "grid")
  }

  grid() { this.apply("grid") }
  list() { this.apply("list") }

  apply(view) {
    const isList = view === "list"
    this.gridTarget.classList.toggle("hidden", isList)
    this.listTarget.classList.toggle("hidden", !isList)
    if (this.hasGridBtnTarget) this._activate(this.gridBtnTarget, !isList)
    if (this.hasListBtnTarget) this._activate(this.listBtnTarget, isList)
    localStorage.setItem(this.storageKeyValue, view)
  }

  _activate(btn, on) {
    btn.classList.toggle("bg-white", on)
    btn.classList.toggle("text-zinc-900", on)
    btn.classList.toggle("shadow-sm", on)
    btn.classList.toggle("text-zinc-500", !on)
    btn.setAttribute("aria-pressed", String(on))
  }
}
